import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
import { applyGen2RestEndpoints } from './gen2Api';
import { identityJsTokenProvider, cognitoCredentialsProvider } from './lib/amplifyTokenProvider';

Amplify.configure(applyGen2RestEndpoints(awsExports), {
  Auth: {
    tokenProvider: identityJsTokenProvider,
    credentialsProvider: cognitoCredentialsProvider,
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
